/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import Vue from "vue"
import Router from "vue-router"
import Meta from "vue-meta"
import store from "@/store"

import account from "./account"
import general from "./general"
import project from "./project"
import admin from "./admin"
import pwa from "./pwa"

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: "history",
  routes: [
    ...account,
    ...general,
    ...project,
    // ...form,
    // ...statistics,
    ...admin,
    ...pwa,
    // ...admin_user,
    // default route
    { path: "*", redirect: { name: "Home" } }
  ]
})

// Détection mode PWA standalone
function isPwaStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  )
}

// Garde de navigation globale
router.beforeEach((to, from, next) => {
  // Redirection automatique vers PWA si installée et route non-PWA
  if (isPwaStandalone() && !to.path.startsWith('/pwa') && !to.path.startsWith('/signin') && !to.path.startsWith('/signup')) {
    if (isAuthenticated()) {
      return next({ name: 'PwaHome' })
    }
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !isAuthenticated()) {
    next({ name: "SignIn", query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

function isAuthenticated() {
  return !!store.state.app.user?.key
}

export default router
